import React, {useState} from "react";
import "../App.css";

function OrderForm({ product ,onBack }){
    const [form, setForm]= useState({
        name:"",
        email:"",
        address: "",
        quantity: 1,


    });

    const handleChange = (e)=>{
        setForm({...form, [e.target.name]:e.target.value});
     
    };

    const handleSubmit =(e) =>{
        e.preventDefault();
        alert( `order plced!\nProduct: ${product.title}\nQuantity: ${form.quantity}\nCustomer: ${form.name}`);

        setForm({name: "", email:"", address:"", quantity:1});

    };

    return(
        <div className="order-form-container">
            <h2 className="section-title">order Form</h2>
            <div className="order-product-info">
             <img src= {product.image} alt= {product.title} className="order-img"/>
             <div> <h3>{product.title}</h3>

             <p>Price:<strong>${product.price}</strong></p>
             </div>
            </div>
            <form onSubmit={handleSubmit} className="order-form">
        <label>Name:</label>
        <input type="text" name="name" value={form.name} onChange={handleChange} required />

        <label>Email:</label>
        <input type="email" name="email" value={form.email} onChange={handleChange} required />

        <label>Address:</label>
        <textarea name="address" value={form.address} onChange={handleChange} required />

        <label>Quantity:</label>
        <input
          type="number"
          name="quantity"
          min="1"
          value={form.quantity}
          onChange={handleChange}
        />
        <button type="submit" className="btn-success">Place Order</button>
        </form>
        <button onClick={onBack} className="btn-primary" style={{marginTop: "15px"}}>
        ← Back to Products
      </button>
        </div>
    );
}

export default OrderForm;